import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import get from 'lodash/get';
import api from 'services/api';
import { setError } from 'store/Manage/actions';
import { selectVulnDetail, selectVulnWorkspace } from 'store/ManageGeneral/selectors';
import { updateVulnGeneral } from 'store/ManageGeneral/actions';
import MarkdownEditor from 'Common/Components/v2/MarkdownEditor';
import ExpandableWrapper from '../ExpandableWrapper';
import useExpandable from 'Hooks/useExpandable';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_VULNS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';

const TAB = 'general';
const ID = 'description';

const Description = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const currentVuln = useSelector(selectVulnDetail);
  const description = get(currentVuln, ID, '');
  const updateValue = (field, value) => dispatch(updateVulnGeneral(currentVuln, field, value));
  const canUpdate = useSelector((state) => selectAllowedByRole(state, FEATURE_VULNS, PERMISSION_TYPES.UPDATE));
  const disabled = !canUpdate;
  const vulnId = get(currentVuln, '_id', 0);
  const isExpanded = useExpandable(TAB, ID, description, vulnId);
  const workspaceSelected = useSelector(selectVulnWorkspace);

  const onImageUpload = async (file) => {
    try {
      const responseSession = await api.faraday.getSession();
      const filename = file.name.replace(/\s+/g, '');
      const renameEvidence = new File([file], filename);
      const fd = new FormData();
      fd.append('csrf_token', responseSession.csrf_token);
      fd.append('file', renameEvidence);
      const response = await api.attachments.saveAttachments(workspaceSelected, vulnId, fd);
      if (response && (response.success !== false)) {
        return `/_api/v3/ws/${workspaceSelected}/vulns/${vulnId}/attachment/${filename}`;
      }
    } catch (e) {
      dispatch(setError(e.message));
    }
  };

  return (
    <ExpandableWrapper defaultValue={ isExpanded } title={ intl.formatMessage({ id: 'manage.detail.tab.general.description' }) } tab={ TAB } id={ ID }>
      <MarkdownEditor
        value={ description }
        onBlur={ (value) => updateValue('desc', value) }
        disabled={ disabled }
        minHeight={ 170 }
        uploadImage
        onImageUpload={ onImageUpload }
      />
    </ExpandableWrapper>
  );
};

export default Description;
